import { CustomOrderType } from '../../carts/CustomOrderType';
import { UpdateCartEntryQuantityResult } from '../../../graphql/cart/updateProductQuantityInCartEntry';
import { createAction } from '@reduxjs/toolkit';

export interface ApiCartUpdateCartEntryQuantityRequestedPayload {
  readonly actionId: number;
  readonly customOrderType: CustomOrderType;
  readonly entryId: string;
  readonly quantity: number;
  readonly parentActionId: number;
}

export const apiCartUpdateCartEntryQuantityRequestedType =
  'api/cart/updateCurrentCartEntryQuantity--requested';
export const apiCartUpdateCartEntryQuantityRequested =
  createAction<ApiCartUpdateCartEntryQuantityRequestedPayload>(
    apiCartUpdateCartEntryQuantityRequestedType
  );

export type ApiCartUpdateCartEntryQuantityRequestedAction = ReturnType<
  typeof apiCartUpdateCartEntryQuantityRequested
>;

export interface ApiCartUpdateCartEntryQuantitySucceededPayload {
  readonly cartId: string | null;
  readonly entryId: string;
  readonly quantity: number;
  readonly result: UpdateCartEntryQuantityResult;
  readonly requestedActionId: number;
  readonly parentActionId: number;
}

export const apiCartUpdateCartEntryQuantitySucceededType =
  'api/cart/updateCurrentCartEntryQuantity--succeeded';
export const apiCartUpdateCartEntryQuantitySucceeded =
  createAction<ApiCartUpdateCartEntryQuantitySucceededPayload>(
    apiCartUpdateCartEntryQuantitySucceededType
  );

export type ApiCartUpdateCartEntryQuantitySucceededAction = ReturnType<
  typeof apiCartUpdateCartEntryQuantitySucceeded
>;

export interface ApiCartUpdateCartEntryQuantityFailedPayload {
  readonly requestedActionId: number;
  readonly parentActionId: number;
}

export const apiCartUpdateCartEntryQuantityFailedType =
  'api/cart/updateCurrentCartEntryQuantity--failed';
export const apiCartUpdateCartEntryQuantityFailed =
  createAction<ApiCartUpdateCartEntryQuantityFailedPayload>(
    apiCartUpdateCartEntryQuantityFailedType
  );
export type ApiCartUpdateCartEntryQuantityFailedAction = ReturnType<
  typeof apiCartUpdateCartEntryQuantityFailed
>;
